var $ = jQuery;

// Once the infinite scroll ajax loads it removed the markup for the icon.
// This function will insert a new icon once the ajax completes.
function injectIconAfterAjax() {

  // Create an event listener for the ajax complete function.
  jQuery(document).ajaxComplete(function(e) {

    // Ensure the button exists to prevent any errors.
    if(jQuery('.person-list-small__more').length > 0 && jQuery('.person-list-small__more').find('.heritage-icon-expand').length < 1) {

      // Create the icon.
      var icon = document.createElement('i');

      // Give the icon it's attribues and classes.
      jQuery(icon).addClass('heritage-icon-expand').attr('aria-hidden', 'true');

      // Append the icon to the see more button.
      jQuery('.person-list-small__more').append(icon);
    }
  });
}

function setActiveTab(targetTab) {
  $('.about-page__tab-labels label[for="' + targetTab + '"]').addClass('active').siblings().removeClass('active');
  $('.about-page__tab-select').val(targetTab);
}

function aboutPageTabs() {
  if($('.about-page__tabs').length) {
    //synch active label with active selectbox
    var initialActiveId = $('.about-page__tab-labels label.active').attr('for');
    setActiveTab(initialActiveId);
    $('.about-page__tab-select').removeClass('invisible');
  }

  //change page when changing select box value (mobile navigation)
  $('.about-page__tab-select').on('change', function(e) {
    let $tabValue = $('.about-page__tab-select option:selected').attr('value');
    let $linkElm = $('.about-page__tab-labels').find('[for="' + $tabValue + '"]').find('a');
    window.open($linkElm[0].href, '_self');
  });

  injectIconAfterAjax();
}

export { aboutPageTabs };
